<template>
  <div
    class="rs-dropdown"
    :class="[
      { 'rs-dropdown--active': isDropdownActive },
      { 'rs-dropdown--full': isFull },
      { 'rs-dropdown--hover': isHover },
      `rs-dropdown--${align}`
    ]"
    @mouseover="handleMouseoverDropdown"
    @mouseleave="handleMouseleaveDropdown"
  >
    <div class="rs-dropdown__trigger"  @click="handleTriggerClick">
      <slot name="dropdown-trigger">Trigger</slot>
    </div>
    <div class="rs-dropdown__body" role="menu" v-show="isDropdownActive">
      <span class="rs-dropdown__caret" />
      <div class="rs-dropdown__fill"></div>
      <div class="rs-dropdown__content">
        <slot name="dropdown-content" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'RsDropdown',

  props: {
    align: {
      type: String,
      default: 'bottom-left' // top-left, bottom-left, top-right, bottom-right
    },
    isFull: Boolean,
    isHover: Boolean
  },

  setup(props) {
    const isDropdownActive = ref(false)

    const handleMouseoverDropdown = (event) => {
      event.stopPropagation()

      if (!props.isHover) return
      open()
    }

    const handleMouseleaveDropdown = (event) => {
      event.stopPropagation()

      if (!props.isHover) return
      close()
    }

    const handleTriggerClick = () => {
      toggle()
    }

    const toggle = () => {
      if (props.isHover) return
      isDropdownActive.value = !isDropdownActive.value
    }

    const open = () => {
      isDropdownActive.value = true
    }

    const close = () => {
      isDropdownActive.value = false
    }

    return {
      isDropdownActive,
      handleMouseoverDropdown,
      handleMouseleaveDropdown,
      handleTriggerClick,
      toggle,
      open,
      close
    }
  }
}
</script>

<style lang="scss" scoped>
.rs-dropdown {
  position: relative;

  &__caret {
    position: absolute;
    left: 18px;
    display: block;
    width: 12px;
    height: 12px;
    background-color: #fff;
    user-select: none;
    z-index: 101;
  }

  &__body {
    min-width: 200px;
    position: absolute;
    z-index: 10000;
    background-color: transparent;
  }

  &__content {
    border: 1px solid #cbd5e0;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05);
  }

  &__fill {
    position: relative;
    z-index: -1;
    height: 10px;
    width: 100%;
    background: transparent;
  }

  &--top-left {
    .rs-dropdown__body {
      display: flex;
      flex-direction: column-reverse;
      top: -100%;
      left: 0;
    }

    .rs-dropdown__caret {
      bottom: -2px;
      border-bottom: 1px solid #cbd5e0;
      border-right: 1px solid #cbd5e0;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  &--top-right {
    .rs-dropdown__body {
      display: flex;
      flex-direction: column-reverse;
      top: -100%;
      right: 0;
    }

    .rs-dropdown__caret {
      bottom: -2px;
      border-bottom: 1px solid #cbd5e0;
      border-right: 1px solid #cbd5e0;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  &--bottom-left {
    .rs-dropdown__body {
      left: 0;
    }

    .rs-dropdown__caret {
      top: 10px;
      border-top: 1px solid #cbd5e0;
      border-left: 1px solid #cbd5e0;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  &--bottom-right {
    .rs-dropdown__body {
      right: 0;
    }

    .rs-dropdown__caret {
      top: 10px;
      border-top: 1px solid #cbd5e0;
      border-left: 1px solid #cbd5e0;
      transform: translateY(-50%) rotate(45deg);
    }
  }

  &--full {
    .rs-dropdown__body {
      width: 100%;
    }
  }
}
</style>
